/* eslint-disable */
import FuseAnimate from '@/@fuse/core/FuseAnimate';
import CustomButton from '@/app/customComponents/CustomButton/CustomButton';
import CustomDatePicker from '@shared/customComponents/CustomDatePicker/CustomDatePicker';
import { getMedications, getRooms } from '@/app/services/reports/reports';
import * as Actions from '@/app/store/actions';
import { generateAgeString } from '@/utils/utils';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
	Avatar,
	CircularProgress,
	FormControl,
	IconButton,
	InputAdornment,
	InputLabel,
	MenuItem,
	Paper,
	Select,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	TextField,
	Typography,
} from '@material-ui/core';
import { Close } from '@material-ui/icons';
import moment from 'moment';
import { useEffect, useRef, useState } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useDispatch, useSelector } from 'react-redux';
import { useReactToPrint } from 'react-to-print';
// import ProfileInfoCard from './ProfileInfoCard';
import { useNavigate } from 'react-router-dom';

export default function Medications() {
	const dispatch = useDispatch();
	const user = useSelector(({ auth }) => auth.user);
	const navigate = useNavigate();
	const [rows, setRows] = useState([]);
	const [isLoading, setIsLoading] = useState(false);
	const [iisLoading, ssetIsLoading] = useState(false);
	const [hasMore, setHasMore] = useState(false);
	const [firstLoad, setFirstLoad] = useState(true);
	const [fetchingMore, setFetchingMore] = useState(false);
	const [refresh, setRefresh] = useState(false);
	const checkInReportRef = useRef(null);
	const [fromDate, setFromDate] = useState('');
	const [toDate, setToDate] = useState('');
	const [fromDate1, setFromDate1] = useState();
	const [toDate1, setToDate1] = useState();
	const [page, setPage] = useState(1);
	const [filters, setFilters] = useState({
		room_id: '',
		status: 1,
		fromDate: '',
		toDate: '',
		school_id: user.school?.id || user.data?.school?.id,
	});

	const [schools, setSchool] = useState([]);
	const [rooms, setRooms] = useState([]);
	const [contact, setContact] = useState('');
	const [allStdPage, setAllStdPage] = useState(1);
	const [studentPage, setStudentPage] = useState(1);
	const [date, setDate] = useState(new Date());
	const [roomPage, setRoomPage] = useState(1);
	const [defaultUser, setDefaultUser] = useState(false);
	const [searchQuery, setSearchQuery] = useState('');

	const handleSearch = (e) => {
		setSearchQuery(e.target.value);
	};

	const handlePrint = useReactToPrint({
		content: () => checkInReportRef.current,
	});

	useEffect(() => {
		let isMounted = true;
		getRooms('', roomPage)
			.then((res) => {
				if (!isMounted) return;
				setRooms([...rooms, ...res.data.data]);
				if (res.data.current_page < res.data.last_page) {
					setRoomPage(roomPage + 1);
				}
			})
			.catch((err) => {
				if (!isMounted) return;
				dispatch(
					Actions.showMessage({
						message: 'Failed to get rooms.',
						autoHideDuration: 1500,
						variant: 'error',
					}),
				);
			});
		return () => {
			isMounted = false;
		};
	}, [roomPage, dispatch]);

	// useEffect(() => {
	// 	const id = setTimeout(
	// 		() => {
	// 			setIsLoading(true);
	// 			setFirstLoad(false);
	// 			getMedications(filters, 1, searchQuery)
	// 				.then(res => {
	// 					if (res.data.last_page > res.data.current_page) {
	// 						setHasMore(true);
	// 					} else {
	// 						setHasMore(false);
	// 					}
	// 					setPage(res.data.current_page + 1);
	// 					setRows(res.data.data);
	// 				})
	// 				.catch(err => {
	// 					dispatch(
	// 						Actions.showMessage({
	// 							message: 'Failed to fetch data, please refresh',
	// 							variant: 'error'
	// 						})
	// 					);
	// 				})
	// 				.finally(() => {
	// 					setIsLoading(false);
	// 				});
	// 		},
	// 		firstLoad ? 0 : 1000
	// 	);

	// 	return _ => {
	// 		clearTimeout(id);
	// 	};
	// 	// eslint-disable-next-line
	// }, []);

	const ApplyFilters = () => {
		setRows([]);
		setIsLoading(true);
		setFirstLoad(false);
		const timeout = setTimeout(
			() => {
				getMedications(filters, 1, searchQuery)
					.then((res) => {
						setFirstLoad(false);
						setRows(res.data.data);
						if (res.data.last_page > res.data.current_page) {
							setHasMore(true);
						} else {
							setHasMore(false);
						}
						setPage(res.data.current_page + 1);
						setContact(filters?.contact_type);
						dispatch(
							Actions.showMessage({
								message: 'Report has been generated',
								variant: 'success',
							}),
						);
						// setPage(res.data.current_page + 1);
					})
					.catch((err) => {
						dispatch(
							Actions.showMessage({
								message: 'Failed to fetch data, please refresh',
								variant: 'error',
							}),
						);
					})
					.finally(() => {
						setIsLoading(false);
					});
			},
			firstLoad ? 0 : 1000,
		);
		setPage(1);
		return () => {
			clearTimeout(timeout);
		};
	};

	const handleLoadMore = () => {
		setFetchingMore(true);
		getMedications(filters, page, searchQuery)
			.then((res) => {
				if (res.data.last_page > res.data.current_page) {
					setHasMore(true);
				} else {
					setHasMore(false);
				}
				setPage(res.data.current_page + 1);
				setRows(rows.concat(res.data.data));
				setFetchingMore(false);
			})
			.catch((err) => {
				setFetchingMore(false);
				dispatch(
					Actions.showMessage({
						message: 'Failed to fetch data, please refresh',
						variant: 'error',
					}),
				);
			});
	};

	const handleFilters = (ev) => {
		const { name, value } = ev.target;
		setFilters({ ...filters, [name]: value });
	};

	const handleExport = () => {
		// setFetchingMore(true);
		// ssetIsLoading(true);
		// const tempLink = document.createElement('a');
		// tempLink.href = `http://localhost:5000/api/v1/medications?export=1&name=${searchQuery}&room_id=${
		// 	filters?.room_id == 'All' ? '' : filters?.room_id
		// }&status=${filters?.status}&date_from=${filters?.fromDate}&date_to=${filters?.toDate}`;
		// tempLink.click();

		ssetIsLoading(true);
		getMedications(filters, 1, searchQuery, 1)
			.then((res) => {
				const blob = new Blob([res.data], {
					type: 'text/csv',
				});
				const link = document.createElement('a');
				link.setAttribute('target', '_blank');
				link.href = window.URL.createObjectURL(blob);
				link.setAttribute('download', `Medication_report_${new Date().getTime()}.csv`);
				document.body.appendChild(link);
				link.click();
				// Clean up and remove the link
				link.parentNode.removeChild(link);
				ssetIsLoading(false);
			})
			.catch((err) => {
				dispatch(
					Actions.showMessage({
						message: 'Failed to Export',
						variant: 'error',
					}),
				);
				ssetIsLoading(false);
			})
			.finally(() => {
				ssetIsLoading(false);
			});
	};

	// const handleProfileCard = (row, self) => {
	// 	dispatch(
	// 		Actions.openDialog({
	// 			children: <ProfileInfoCard row={row} self={self} />
	// 		})
	// 	);
	// };

	// useEffect(() => {
	// 	if (fromDate1) {
	// 		if (dayjs(fromDate1).format('YYYY-MM-DD') === fromDate) {
	// 			return;
	// 		}
	// 		setFromDate(dayjs(fromDate1).format('YYYY-MM-DD'));
	// 	}
	// 	if (toDate1) {
	// 		if (dayjs(toDate1).format('YYYY-MM-DD') === toDate) {
	// 			return;
	// 		}
	// 		setToDate(dayjs(toDate1).format('YYYY-MM-DD'));
	// 	}
	// }, [fromDate1, toDate1]);
	return (
		<FuseAnimate animation="transition.slideLeftIn" duration={600}>
			<div className="mx-auto allergy-cont">
				<div className="flex items-center flex-nowrap justify-between">
					<div className="reports-topDiv">
						<h1 className="my-16">
							{' '}
							<span className="icon-color">
								<IconButton
									onClick={() => {
										navigate('/reports');
									}}
								>
									<img alt="filter" className="backBtn-img" src="assets/images/arrow-long.png" width="24px" />
								</IconButton>
							</span>
							<span className="text-pd-xl self-end font-bold mr-28">Medical</span>
						</h1>
						<p>Student medical by classroom or for your entire school.</p>
					</div>
					<div className="flex justify-between">
						<div className="flex">
							<div className="self-end btn-aller">
								<span>
									{!iisLoading ? (
										<a>
											<CustomButton
												height="40px"
												marginRight="17px"
												onClick={handleExport}
												variant="primary"
												width="100px"
											>
												<span className="mr-4">
													<FontAwesomeIcon icon={faDownload} />
												</span>
												Export
											</CustomButton>
										</a>
									) : (
										<div className="circle-bar">
											<CircularProgress size={35} />
										</div>
									)}
									<CustomButton height="40px" onClick={() => handlePrint()} variant="secondary" width="100px">
										<i aria-hidden="true" className="fa fa-print" /> Print
									</CustomButton>
									{/* <div className="help-btn cursor-pointer">
										<img src="assets/images/CENTER.png" />
										Help Center
									</div> */}
								</span>
							</div>
						</div>
					</div>
				</div>

				<div className="flex items-center flex-nowrap justify-between">
					<span className="text-pd-2xl self-end font-extrabold mr-28" />
					<div className="flex justify-between">
						<div className="flex">
							<div className="mx-8">
								<TextField
									InputProps={{
										endAdornment: (
											<InputAdornment position="end">
												<IconButton
													id="search-icon"
													onClick={() => {
														document.getElementById('search-input').focus();
													}}
												>
													<img alt="search-icon" height="80%" src="assets/images/search-icon.svg" width="80%" />
												</IconButton>
											</InputAdornment>
										),
									}}
									className="mr-10"
									id="search-input"
									label="Search by Student"
									onChange={handleSearch}
									style={{ width: 170 }}
									value={searchQuery}
								/>
							</div>

							<div className="mx-8">
								<FormControl>
									<InputLabel id="room_id">Room</InputLabel>
									<Select
										endAdornment={
											filters.room_id ? (
												<IconButton className="mr-16" id="clear-room-filter" size="small">
													<Close
														fontSize="small"
														onClick={() => {
															setFilters({
																...filters,
																room_id: '',
															});
														}}
													/>
												</IconButton>
											) : (
												''
											)
										}
										id="room_id"
										label="Room"
										labelId="roomLabel"
										name="room_id"
										onChange={handleFilters}
										style={{ width: 150 }}
										value={filters.room_id}
									>
										<MenuItem value="All">All</MenuItem>
										{rooms.length ? (
											rooms.map((room) => {
												return (
													<MenuItem id={room.id} key={room.id} value={room.id}>
														{room.name}
													</MenuItem>
												);
											})
										) : (
											<MenuItem disabled>Loading...</MenuItem>
										)}
									</Select>
								</FormControl>
							</div>

							<div className="mx-8">
								<FormControl>
									<InputLabel id="status">Status</InputLabel>
									<Select
										endAdornment={
											filters.status ? (
												<IconButton className="mr-16" id="clear-room-filter" size="small">
													<Close
														fontSize="small"
														onClick={() => {
															setFilters({
																...filters,
																status: '',
															});
														}}
													/>
												</IconButton>
											) : (
												''
											)
										}
										id="status"
										label="status"
										labelId="status"
										name="status"
										onChange={handleFilters}
										style={{ width: 150 }}
										value={filters.status}
									>
										<MenuItem value="1">Active</MenuItem>
										<MenuItem value="0">Inactive</MenuItem>
									</Select>
								</FormControl>
							</div>
							<div className="mx-10 student-date-field" style={{ width: 150 }}>
								<CustomDatePicker
									id="date-from"
									label="Date From"
									maxDate={filters.toDate}
									setValue={(Date) => {
										setFilters({ ...filters, fromDate: Date?.format('YYYY-MM-DD') || '' });
									}}
									value={filters.fromDate}
								/>
							</div>
							<div className="mr-20 ml-10 student-date-field" style={{ width: 150 }}>
								<CustomDatePicker
									id="date-to"
									label="Date To"
									minDate={filters.fromDate}
									setValue={(Date) => {
										setFilters({ ...filters, toDate: Date?.format('YYYY-MM-DD') || '' });
									}}
									value={filters.toDate}
								/>
							</div>
						</div>

						<div className="self-end">
							<span>
								<span className="mx-4">
									<CustomButton
										disabled={
											!filters.fromDate && !filters.toDate && !filters.status && !filters.room_id ? !searchQuery : null
										}
										fontSize="15px"
										height="43"
										onClick={() => {
											ApplyFilters();
										}}
										variant="secondary"
										width="140px"
									>
										Apply
									</CustomButton>
								</span>
							</span>
						</div>
					</div>
				</div>

				{/* table  */}
				<TableContainer className="allergy-table-cont" component={Paper} id="Scrollable-table">
					<div style={{ display: 'none' }}>
						<div className="p-32" ref={checkInReportRef}>
							<div className="flex flex-row justify-between">
								<div>
									<img alt="" src="assets/images/logos/logo.png" />
								</div>
								<div style={{ textAlign: 'right' }}>
									<Typography
										style={{
											maxWidth: '220px',
										}}
										variant="subtitle1"
									>
										<span style={{ display: 'block', marginBottom: '5px', writingMode: '' }}>
											{user?.data?.school?.address}
										</span>
									</Typography>
									<Typography variant="subtitle1">+ {user?.data?.phone}</Typography>
									<Typography variant="subtitle1">{user?.data?.email}</Typography>
								</div>
							</div>
							<div style={{ marginBottom: '20px' }}>
								<span>
									<strong>Date: </strong>
								</span>
								<span>{moment(date).format('dddd, DD MMMM YYYY')}</span>
							</div>
							<div className="pdf-heading">
								<h1 className="font-extrabold">Medical Report</h1>
							</div>

							<Table className="student-table" stickyHeader style={{ width: '100%' }}>
								<TableHead>
									<TableRow>
										<TableCell className="bg-white studentTableHeader" style={{ width: '27%' }}>
											Student
										</TableCell>
										<TableCell className="bg-white studentTableHeader" style={{ width: '25%' }}>
											Parents
										</TableCell>

										<TableCell className="bg-white studentTableHeader" style={{ width: '15%' }}>
											Medication
										</TableCell>
										<TableCell className="bg-white studentTableHeader" style={{ width: '10%' }}>
											Frquency
										</TableCell>
										<TableCell className="bg-white studentTableHeader" style={{ width: '30%' }}>
											Start/End Date
										</TableCell>
									</TableRow>
								</TableHead>
								<TableBody className="">
									{isLoading ? (
										<TableRow>
											<TableCell align="center" colSpan={8}>
												{/* <CircularProgress size={35} /> */}
											</TableCell>
										</TableRow>
									) : !rows.length && !firstLoad ? (
										<TableRow>
											<TableCell align="center" colSpan={8}>
												No record found
											</TableCell>
										</TableRow>
									) : (
										rows?.map((row) => (
											<TableRow key={row.id}>
												<TableCell
													// style={{
													// 	fontSize: '13px',
													// 	maxWidth: '100px',
													// 	fontWeight: 'bold',
													// 	overflow: 'hidden',
													// 	textOverflow: 'ellipsis',
													// 	whiteSpace: 'nowrap'
													// }}
													className="bg-white "
												>
													<div
														className="flex cursor-pointer"
														// onClick={() => goTostudentInformation(row)}
													>
														<Avatar className="mr-6" src={row?.thumb} />
														<div className="flex flex-col items-start">
															<div className="medication-homeroom break-word">{row?.home_room?.name}</div>
															<div className="report-medication break-word">{row?.full_name}</div>
															<div className="font-normal student-age-font">{generateAgeString(row.date_of_birth)}</div>
														</div>
													</div>
												</TableCell>
												<TableCell style={{ fontWeight: 700 }}>
													<div className="flex flex-col">
														{row?.contacts
															.map((parent, index) => (
																<div
																	className="flex items-center cursor-pointer mb-10"
																	key={index}
																	// onClick={() => handleProfileCard(row, row.parent)}
																>
																	<Avatar className="mr-4" src={parent?.thumb} />
																	<div className="flex flex-col items-center">
																		<div className="medication-parent-name break-word">
																			{parent?.first_name} {parent?.last_name}
																		</div>
																		<div className="medication-parent-relation self-start ">
																			{parent?.relation_with_child}
																		</div>
																	</div>
																</div>
															))
															.splice(0, 2)}
													</div>
												</TableCell>

												<TableCell
													// style={{
													// 	fontSize: '13px',
													// 	maxWidth: '100px',
													// 	fontWeight: 'bold',
													// 	overflow: 'hidden',
													// 	textOverflow: 'ellipsis',
													// 	whiteSpace: 'nowrap'
													// }}
													className="bg-white "
												>
													{row?.medicine?.map((item, index) => (
														<div className="report-medication">{item?.name}</div>
													))}
												</TableCell>
												<TableCell
													// style={{
													// 	fontSize: '13px',
													// 	maxWidth: '100px',
													// 	fontWeight: 'bold',
													// 	overflow: 'hidden',
													// 	textOverflow: 'ellipsis',
													// 	whiteSpace: 'nowrap'
													// }}
													className="bg-white "
												>
													{row?.medicine?.map((item, index) => (
														<div className="report-medication">{item?.frequency}</div>
													))}
												</TableCell>
												<TableCell
													// style={{
													// 	fontSize: '13px',
													// 	maxWidth: '100px',
													// 	fontWeight: 'bold',
													// 	overflow: 'hidden',
													// 	textOverflow: 'ellipsis',
													// 	whiteSpace: 'nowrap'
													// }}
													className="bg-white "
												>
													{row?.medicine?.map((item, index) => (
														<div className="">
															{/* <div className="report-medication">{item?.start_date}</div>
													<div className="report-medication">{item?.end_date}</div> */}
															<div className="report-medication">{`${moment(item?.start_date).format(
																'MM/DD/YY',
															)} - ${moment(item?.end_date).format('MM/DD/YY')}`}</div>
														</div>
													))}
												</TableCell>
											</TableRow>
										))
									)}
									{/* {fetchingMore ? (
										<TableRow>
											<TableCell align="center" colSpan={8}>
												<CircularProgress size={35} />
											</TableCell>
										</TableRow>
									) : (
										<></>
									)} */}
								</TableBody>
							</Table>
						</div>
					</div>
					<Table className="student-table" stickyHeader style={{ width: '100%' }}>
						<TableHead>
							<TableRow>
								<TableCell className="bg-white studentTableHeader" style={{ width: '25%' }}>
									Student
								</TableCell>
								<TableCell className="bg-white studentTableHeader" style={{ width: '35%' }}>
									Parents
								</TableCell>

								<TableCell className="bg-white studentTableHeader" style={{ width: '13%' }}>
									Medication
								</TableCell>
								<TableCell className="bg-white studentTableHeader" style={{ width: '13%' }}>
									Frquency
								</TableCell>
								<TableCell className="bg-white studentTableHeader" style={{ width: '13%' }}>
									Start/End Date
								</TableCell>
							</TableRow>
						</TableHead>
						<TableBody className="">
							{firstLoad ? (
								<TableRow>
									<TableCell align="center" colSpan={8}>
										Generate your report
									</TableCell>
								</TableRow>
							) : isLoading ? (
								<TableRow>
									<TableCell align="center" colSpan={8}>
										<CircularProgress size={35} />
									</TableCell>
								</TableRow>
							) : !rows.length && !isLoading ? (
								<TableRow>
									<TableCell align="center" colSpan={8}>
										No record found
									</TableCell>
								</TableRow>
							) : (
								rows?.map((row) => (
									<TableRow key={row.id}>
										<TableCell className="bg-white">
											<div
												className="flex cursor-pointer"
												// onClick={() => goTostudentInformation(row)}
											>
												<Avatar className="mr-6" src={row?.thumb} />
												<div className="flex flex-col items-start">
													<div className="medication-homeroom break-word font-bold">{row?.home_room?.name}</div>
													<div className="report-medication break-word">{row?.full_name}</div>
													<div className="font-normal student-age-font">{generateAgeString(row.date_of_birth)}</div>
												</div>
											</div>
										</TableCell>
										<TableCell style={{ fontWeight: 700 }}>
											<div className="flex overflow-auto">
												{row?.contacts
													.map((parent, index) => (
														<div
															className="flex items-center cursor-pointer"
															key={index}
															// onClick={() => handleProfileCard(row, row.parent)}
														>
															<Avatar className="mr-4" src={parent?.thumb} />
															<div className="flex flex-col items-center">
																<div className="medication-parent-name break-word">
																	{parent?.first_name} {parent?.last_name}
																</div>
																<div className="medication-parent-relation self-start">
																	{parent?.relation_with_child}
																</div>
															</div>
														</div>
													))
													.splice(0, 2)}
											</div>
										</TableCell>

										<TableCell
											className="bg-white"
											style={{
												fontSize: '13px',
												maxWidth: '100px',
												fontWeight: 'bold',
												overflow: 'hidden',
												textOverflow: 'ellipsis',
												whiteSpace: 'nowrap',
											}}
										>
											{row?.medicine?.map((item, index) => (
												<div className="report-medication">{item?.name}</div>
											))}
										</TableCell>
										<TableCell
											className="bg-white"
											style={{
												fontSize: '13px',
												maxWidth: '100px',
												fontWeight: 'bold',
												overflow: 'hidden',
												textOverflow: 'ellipsis',
												whiteSpace: 'nowrap',
											}}
										>
											{row?.medicine?.map((item, index) => (
												<div className="report-medication">{item?.frequency}</div>
											))}
										</TableCell>
										<TableCell
											className="bg-white truncate"
											style={{
												fontSize: '13px',
												maxWidth: '100px',
												fontWeight: 'bold',
												overflow: 'hidden',
												textOverflow: 'ellipsis',
												whiteSpace: 'nowrap',
											}}
										>
											{row?.medicine?.map((item, index) => (
												<div className="">
													{/* <div className="report-medication">{item?.start_date}</div>
													<div className="report-medication">{item?.end_date}</div> */}
													<div className="report-medication">{`${moment(item?.start_date).format(
														'MM/DD/YY',
													)} - ${moment(item?.end_date).format('MM/DD/YY')}`}</div>
												</div>
											))}
										</TableCell>
									</TableRow>
								))
							)}
							{fetchingMore ? (
								<TableRow>
									<TableCell align="center" colSpan={8}>
										<CircularProgress size={35} />
									</TableCell>
								</TableRow>
							) : (
								<></>
							)}
						</TableBody>
					</Table>
				</TableContainer>
				<InfiniteScroll
					dataLength={rows?.length}
					hasMore={hasMore}
					next={handleLoadMore}
					scrollableTarget="Scrollable-table"
				/>
			</div>
		</FuseAnimate>
	);
}
